export default "__VITE_ASSET__ShuLeTsV__"